import axios from "axios";
import { API_URL } from "../utils/ApiLinks"; 

// Buscar por texto
export const searchGeo = async (query: string, token?: string) => {
  try {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await axios.get(`${API_URL}/geocode/search`, {
      params: { query },
      headers,
    });

    return response.data;
  } catch (error: any) {
    console.error("Error en searchGeo:", error);
    throw error.response?.data || error.message;
  }
};

// Buscar por coordenadas
export const reverseGeo = async (lat: number, lon: number, token?: string) => {
  try {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await axios.get(`${API_URL}/geocode/reverse`, {
      params: { lat, lon },
      headers,
    });
    console.log(response)

    return response.data;
  } catch (error: any) {
    console.error("Error en reverseGeo:", error);
    throw error.response?.data || error.message;
  }
};
